import { db_firestore } from "./firebase";
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  startAt,
  endAt,
  doc,
  setDoc,
  addDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

class ApiVentas {
  /**
   * Obtiene todas las ventas ordenadas por fecha (descendente).
   * @returns {Promise<Array<Object>>} - Lista de ventas
   */
  async getVentas() {
    const ventasRef = collection(db_firestore, `/ventas`);
    const q = query(ventasRef, orderBy("fecha", "desc"));

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  }

  /**
   * Obtiene ventas en un rango de fechas.
   * @param {string} fromEpoch - Fecha mínima (Epoch)
   * @param {string} toEpoch - Fecha máxima (Epoch)
   * @returns {Promise<Array<Object>>} - Lista de ventas filtradas
   */
  async getVentasFecha(fromEpoch, toEpoch) {
    const ventasRef = collection(db_firestore, `/ventas`);
    const q = query(
      ventasRef,
      where("fecha", ">=", fromEpoch),
      where("fecha", "<=", toEpoch),
      orderBy("fecha", "desc")
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  }

  /**
   * Crea una nueva venta en Firestore.
   * @param {Object} venta - Objeto con los datos de la venta
   * @returns {Promise<string>} - ID de la venta creada
   */
  async createVenta(venta) {
    const ventasRef = collection(db_firestore, `/ventas`);
    const docRef = await addDoc(ventasRef, venta);
    return docRef.id;
  }

  /**
   * Actualiza una venta existente en Firestore.
   * @param {string} user - ID del usuario
   * @param {Object} venta - Objeto de la venta con `id`
   * @returns {Promise<void>}
   */
  async updateVenta(venta) {
    if (!venta.id) throw new Error("La venta debe tener un ID para actualizarse");

    const ventaRef = doc(db_firestore, `/ventas`, venta.id);
    await setDoc(ventaRef, venta, { merge: true });
  }
}

// Exportamos la instancia de API
const apiVentas = new ApiVentas();
export default apiVentas;
